// Boiler Plate Imports
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import API from "../../api";
import colors from "../../theme/colors";

// Conatiner Component Imports
import { Card } from "@mui/material";
import BreadCrumbs from "../../components/Navigation/breadcrumbs";
import TableHeader from "../../components/Page/tableHeader";
import TableSubHeader from "../../components/Page/tableSubHeader";
import { useParams } from "react-router-dom";
import { ItemLink, TableComponent } from "../../components/Table/dataGridPro";

const Table = React.memo(TableComponent);

const OrganizationOnCallContainer = () => {
  const organization = useSelector((state) => state.organization);
  const [reloadData, setReloadData] = useState(false);

  const dispatch = useDispatch();

  const { organizationId } = useParams();

  const tableColumns = useMemo(
    () => [
      {
        headerName: "Location",
        field: "locationName",
        valueGetter: (value, row) => {
          return row.locationName;
        },
        renderCell: ({ row }) => {
          return (
            <ItemLink to={`/${organizationId}/oncall/${row.locationId}`}>
              {row.locationName}
            </ItemLink>
          );
        },
      },
      {
        headerName: "On Call",
        field: "currentOnCallUserName",
        valueGetter: (value, row) => {
          return row.currentOnCallUserName;
        },
        renderCell: ({ row }) => {
          if (row.currentOnCallUserName === "not set") {
            return (
              <div style={{ color: colors.orange }}>
                {row.currentOnCallUserName}
              </div>
            );
          } else {
            return row.currentOnCallUserName;
          }
        },
      },
      {
        headerName: "Backup 1",
        field: "backupOneUserName",
        valueGetter: (value, row) => {
          return row.backupOneUserName;
        },
        renderCell: ({ row }) => {
          if (row.backupOneUserName === "not set") {
            return (
              <div style={{ color: colors.orange }}>
                {row.backupOneUserName}
              </div>
            );
          } else {
            return row.backupOneUserName;
          }
        },
      },
      {
        headerName: "Backup 2",
        field: "backupTwoUserName",
        valueGetter: (value, row) => {
          return row.backupTwoUserName;
        },
        renderCell: ({ row }) => {
          if (row.backupTwoUserName === "not set") {
            return (
              <div style={{ color: colors.orange }}>
                {row.backupTwoUserName}
              </div>
            );
          } else {
            return row.backupTwoUserName;
          }
        },
      },
      {
        headerName: "Last Updated",
        field: "modifiedDateObject",
        type: "dateTime",
      },
    ],
    []
  );

  useEffect(() => {
    //Set Bread Crumbs
    dispatch(
      setBreadCrumbs([
        {
          title: organization.name,
          link: "/organization",
        },
        {
          title: "On Call",
          link: "/oncall",
        },
      ])
    );
  }, [organization]);

  const dataLayer = {
    GetOrganizationOnCall: async () => {
      const _oncall = await API.OnCall.OnCallGetOrganizationOncall({
        organizationId,
      });
      const rows = _oncall.map((item) => {
        return {
          id: item.location.id,
          locationName: item.location.name,
          locationId: item.location.id,
          currentOnCallUserId: item.oncall.currentOnCallUserId,
          currentOnCallUserName: item.oncall.currentOnCallUser?.firstName
            ? `${item.oncall.currentOnCallUser?.firstName} ${item.oncall.currentOnCallUser?.lastName}`
            : "not set",
          backupOneUserId: item.oncall.backupOneUserId,
          backupOneUserName: item.oncall.backupOneUser?.firstName
            ? `${item.oncall.backupOneUser?.firstName} ${item.oncall.backupOneUser?.lastName}`
            : "not set",
          backupTwoUserId: item.oncall.backupTwoUserId,
          backupTwoUserName: item.oncall.backupTwoUser?.firstName
            ? `${item.oncall.backupTwoUser?.firstName} ${item.oncall.backupTwoUser?.lastName}`
            : "not set",
          modified: item.oncall?.modified ? item.oncall.modified : 0,
          modifiedDateObject: item.oncall?.modified
            ? new Date(item.oncall.modified)
            : "",
        };
      });
      rows.sort((a, b) => {
        return b.modified - a.modified;
      });

      return rows;
    },
  };

  return (
    <>
      
      <Card>
        <TableHeader>
          <div>
            <h2>On Call</h2>
            <TableSubHeader>
              Boreas On-Call allows you to manage who will receive notifications
              in the event of an alarm. View on-call details for your
              organization below. Click on a location name to manage the on-call
              settings for that location.
            </TableSubHeader>
          </div>
        </TableHeader>

        <Table
          columns={tableColumns}
          autoResizeColumns={false}
          label={""}
          isAdminView={false}
          reloadData={reloadData}
          placeholder={"Please create locations to assign users to on call"}
          getRowsFunction={dataLayer.GetOrganizationOnCall}
          initialState={{
            pinnedColumns: { left: ["locationName"] },
            sorting: {
              sortModel: [{ field: "locationName", sort: "asc" }],
            },
          }}
        />
      </Card>
    </>
  );
};

export default OrganizationOnCallContainer;
